import React, { useCallback, useState } from 'react';

import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { Box, Button, Divider, Hidden, Typography } from '@mui/material';
import GridItem from '@jumbo/components/GridItem';
import GridContainer from '@jumbo/components/GridContainer';
import CmtCard from '@coremat/CmtCard';
import CmtCardContent from '@coremat/CmtCard/CmtCardContent';
import { useActiveExteriorSignageQuote, useDeleteExteriorSignageQuoteItem } from 'services/Data/ExteriorSignageQuoteService';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import DeleteModal from '@acnb/CustomComponents/_Modals/DeleteModal';
import ExteriorSignageQuoteItemCard from '../ExteriorSignageQuote/ExteriorSignageQuoteItemCard';
import CmtCardHeader from '@coremat/CmtCard/CmtCardHeader';
import { ApplicationIcons } from 'icons/ApplicationIcons';
import useMobile from 'services/Hooks/useMobile';

const useStyles = makeStyles(theme => ({
  mainButton: {
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0 0 1rem rgba(255, 222, 0, 0.9)',
    },
  },
  guideLink: {
    color: 'rgba(51, 51, 51, 0.8)',
    textDecoration: 'underline',
    '&:hover': {
      color: 'rgba(27, 27, 27, 0.8)',
      textDecoration: 'underline',
    },
  },
}));

const CompleteExteriorSignangeSubmisson = () => {
  const classes = useStyles();

  let hist = useHistory();
  const isMobile = useMobile();

  const [itemToDelete, setItemToDelete] = useState();

  const { t } = useTranslation();
  const accountReducer = useSelector(state => state.AccountReducer);

  const { data: exteriorSignageQuote } = useActiveExteriorSignageQuote(accountReducer.isLoggedIn);

  const { mutate: deleteExteriorSignageQuoteItem } = useDeleteExteriorSignageQuoteItem();

  const handleOpenDeleteItemModal = useCallback(
    item => {
      setItemToDelete(item);
    },
    [setItemToDelete],
  );

  const handleCloseDeleteModal = useCallback(() => {
    setItemToDelete(null);
  }, [setItemToDelete]);

  return (
    <Box className={classes.pageFull}>
      <DeleteModal
        handleCloseModal={handleCloseDeleteModal}
        item={itemToDelete}
        message={t('deleteItemFromExteriorSignageQuoteText', {
          sku: itemToDelete?.sku,
          name: itemToDelete?.name,
        })}
        deleteAction={deleteExteriorSignageQuoteItem}
      />
      <CmtCard sx={{ marginTop: 5 }}>
        <CmtCardHeader title={t('exteriorSignageQuote')} icon={<ApplicationIcons.ExteriorSignage />}></CmtCardHeader>
        <CmtCardContent>
          {exteriorSignageQuote?.quoteItems?.map(qi => (
            <ExteriorSignageQuoteItemCard key={qi.id} item={qi} handleOpenDeleteItemModal={handleOpenDeleteItemModal} />
          ))}
          <GridContainer className={isMobile ? '' : classes.cartFooter}>
            <Hidden mdUp implementation="js">
              <GridItem xs={12}>
                <Divider />
              </GridItem>
            </Hidden>
            <GridItem xs={12} lg={9} md={7}></GridItem>
            <GridItem xs={12} lg={3} md={5}>
              <Button
                variant="contained"
                color="secondary"
                sx={{
                  borderRadius: 0,
                  color: '#000',
                  mt: 6,
                  width: '100%',
                  boxShadow: 'none',
                  '&:hover': {
                    backgroundColor: '#EFBA29',
                    boxShadow: 'none',
                  },
                }}
                disabled={(exteriorSignageQuote?.quoteItems?.length || 0) <= 0}
                onClick={() => {
                  hist.push('/dealer/home-page/exterior-signage/check-out');
                }}>
                <Typography variant="h1" sx={{ fontSize: { xs: 16, sm: 18, md: 22 }, py: 2 }}>
                  {t('proceedCheckoutExteriorSignageQuote')}
                </Typography>
              </Button>
            </GridItem>
          </GridContainer>
        </CmtCardContent>
      </CmtCard>
    </Box>
  );
};

export default CompleteExteriorSignangeSubmisson;
